export const SERVER_ERROR = 'SERVER_ERROR';
export const INTERNAL_ERROR = 'INTERNAL_ERROR';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const RESET_VALIDATION_ERROR = 'RESET_VALIDATION_ERROR';
export const SERVICE_ERROR = 'SERVICE_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/errorActionTypes.js